// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__K_lLm","colMin":"styles_colMin__w97Ov","colCheckbox":"styles_colCheckbox__1rIV_"};